import { placesQueryKeys as e } from "./usePlacesQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { placesApi as n } from "@maat/api-main";
//#region src/places/useGuestPlaceDetailsQuery.ts
var r = (r) => t({
	queryKey: e.details(r ?? ""),
	queryFn: () => n.getPlaceDetails(r),
	enabled: !!r
});
//#endregion
export { r as useGuestPlaceDetailsQuery };
